import React from 'react';
import { Helmet } from 'react-helmet-async';
import logoImg from '@assets/logo.png';
import styles from './ComingSoon.module.css';

export function ComingSoon() {
  return (
    <main data-maintenance-page="true" className={styles.container}>
      <Helmet>
        <title>Coming Soon | Truck Max Equipment Finance</title>
        <meta name="description" content="We’re working on our website. We’ll be ready soon. Thank you for your patience." />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Coming Soon | Truck Max Equipment Finance" />
        <meta property="og:description" content="We’re working on our website. We’ll be ready soon. Thank you for your patience." />
        <meta name="twitter:title" content="Coming Soon | Truck Max Equipment Finance" />
        <meta name="twitter:description" content="We’re working on our website. We’ll be ready soon. Thank you for your patience." />
      </Helmet>

      <div className={styles.background}>
        <div className={styles.glow} />
        <div className={styles.grid} />
      </div>

      <div className={styles.content}>
        <div className={styles.logoWrapper}>
          <img 
            src={logoImg} 
            alt="Truck Max Equipment Finance" 
            className={styles.logo}
            width={240}
            height={60}
          />
        </div>
        
        <div className={styles.textWrapper}>
          <h1 className={styles.headline}>We’re working on our website</h1>
          <p className={styles.support}>We’ll be ready soon. Thank you for your patience.</p>
        </div>
        
        <div className={styles.accentLine} />
      </div>
    </main>
  );
}
